/* eslint-disable sciencepo-rules/require-story*/
/* Inutile de le tester*/
import * as pageStyles from '../../styles/internal-page/internal-page.module.scss';

import React, { Fragment } from 'react';

import PropTypes from 'prop-types';
import Anchor from '../shared/Anchor';
import Banner from './Banner';
import CkEditor from '../shared/ckeditor/CkEditor';
import DiaporamaCarrousel from '../shared/carrousels/DiaporamaCarrousel';
import FocusCarrousel from '../shared/carrousels/FocusCarrousel';
import Section from './Section';
import TabPanel from '../shared/TabPanel';
import TestimonieDiapo from './TestimonieDiapo';
import ReactComponent from '../shared/widgets/ReactComponent';
import StickyButton from '../shared/StickyButton';
import ImageTextCarousel from '../shared/carrousels/ImageTextCarousel';
import CareNumbers from '../shared/CareNumbers';

const components = {
  'CmsPortalComponentWidgetBanner': Banner,
  'CmsPortalComponentSectionMain': Section,
  'CmsPortalComponentTabTab': TabPanel,
  'CmsPortalComponentWidgetQteCarousel': TestimonieDiapo,
  'CmsPortalComponentWidgetStickyButton': StickyButton,
  'CmsPortalComponentWidgetReactComponent': ReactComponent,
  'CmsPortalComponentWidgetKeyNumberList': CareNumbers,
};

const Content = ({
  elem,
  tweets,
  youtubeVideos,
  siteURL,
  lang,
  locale,
}) => {
  let displayLang = '';
  if (lang) {
    displayLang = lang.toLowerCase();
  }
  const Comps = components[elem.__typename];
  const elemAnchor = elem?.anchor || null;
  if (Comps){
    return (
      <Comps
        elem={elem}
        hasNoTitle
        language={lang}
        locale={locale}
        siteURL={siteURL}
        tweets={tweets}
        youtubeVideos={youtubeVideos}
      />
    );
  }

  if (elem.__typename === 'CmsPortalComponentContentText') {
    return (
      <>
        <Anchor anchor={elemAnchor} />
        <CkEditor elemAnchor={elemAnchor}
          html={elem.text}
          lang={displayLang}
        />
      </>
    );
  }

  if (elem.__typename === 'CmsPortalComponentContentTextShared') {
    const tsh = elem.content_shared?.text_shared;
    if (tsh && tsh.length > 0) {
      const tshe = elem.content_shared.text_shared[0];
      return (
        <>
          {tshe.anchor && <Anchor anchor={tshe.anchor} />}
          <CkEditor html={tshe.text}
            lang={displayLang}
          />
        </>
      );
    }
    return (
      <>
      </>
    );
  }

  if (elem.__typename === 'CmsPortalComponentWidgetCarousel') {
    if (elem.type === 'FOCUS'){
      return (
        <FocusCarrousel
          className={pageStyles.marginBetweenBlocs}
          id={elem.id}
          items={elem.carousel_item}
          subtitle_position={elem.subtitle_position}
          title_orientation={elem.title_orientation}
        />
      );
    }
    if (elem.type === 'TEXT'){
      return (
        <ImageTextCarousel
          className={pageStyles.marginBetweenBlocs}
          items={elem.carousel_item}
        />
      );
    }
    return (
      <DiaporamaCarrousel
        className={pageStyles.marginBetweenBlocs}
        id={elem.id}
        items={elem.carousel_item}
      />
    );
  }

  return null;
};

Content.propTypes = {
  elem: PropTypes.shape({
    __typename: PropTypes.string.isRequired,
    anchor: PropTypes.string,
    action_target: PropTypes.string,
    action_type: PropTypes.string,
    bannerContent: PropTypes.string,
    button: PropTypes.string,
    title: PropTypes.string,
    content: PropTypes.array,
    spacing: PropTypes.bool,
    three_columns: PropTypes.bool,
    TabPanel: PropTypes.array,
    text: PropTypes.string,
    config: PropTypes.object,
    objectClass: PropTypes.string,
    content_shared: PropTypes.shape({
      text_shared: PropTypes.arrayOf(PropTypes.shape({
        anchor: PropTypes.string,
        text: PropTypes.string,
      })),
    }),
    carousel_item: PropTypes.array,
    id: PropTypes.string,
    type: PropTypes.string,
    subtitle_position: PropTypes.string,
    title_orientation: PropTypes.string,
  }).isRequired,
  fullWidth: PropTypes.bool,
  lang: PropTypes.string,
  locale: PropTypes.string,
  siteURL: PropTypes.string,
  tweets: PropTypes.array,
  youtubeVideos: PropTypes.array,
};

export default Content;
